<template>
  <div class="home view-style">
    <!-- header组件 -->
    <el-header />
    <!-- 返回按钮区域 -->
    <div class="back-button">
      <el-button title="返回" route="/home" />
    </div>
    <!-- 左侧公司资料区域, -->
    <div class="company-introduce-area bg-center left-area-style">
      <left-company-info/>
    </div>
    <!-- 右侧气象产品相关展示区域 -->
    <div class="pd-area right-area-style">
      <!-- 天气信息 -->
      <div class="weather-area">
        <weather />
      </div>
      <!-- 折线图 -->
      <div class="scan-area">
        <v-scan-code/>
      </div>
      <!-- 主要产品区域, -->
      <div class="main-products-area">
        <main-products />
      </div>
    </div>
  </div>
</template>

<script>
//引入header,忘记提取模版了,多走一步
import elHeader from "../components/Header";
//引入公共按钮组件,
import elButton from "@/components/Button";
//引入扫码量折线图，
import scanCodeChart from "../components/Company/enterpriseScanCodeNum";
//引入左侧公司具体信息组件,
import leftCompanyInfo from "../components/Company/LeftCompanyInfo";
//引入右侧天气组件,
import Weather from "../components/Company/Weather";
//引入右侧主要产品组件,
import MainProducts from "../components/Company/MainProducts";
//引入api
import {getCommpany} from "../api/region.js";
import {mapGetters} from "vuex";
export default {
  data() {
    return {
      //真正要渲染的数组,
      renderArray: null,
      //公司页面的baseUrl
      baseUrl: "http://gateway.zhenyuanma.com/portal"//20210205zym.so换成zhenyuanma.com
    };
  },

  components: {
    elHeader,
    elButton,
    'v-scan-code':scanCodeChart,
    leftCompanyInfo,
    Weather,
    MainProducts
  },
    watch: {
    $route(to, from) {
      if (/\/company/gi.test(to.path)) {
          //拿到传过来的id
          const id = this.orgIdNum;
          this.data = [];
          //执行取数据函数,
         this.getData(id);
      }
    }
  },
  mounted() {
    //拿到传过来的id
    const id = this.orgIdNum;
    this.data = [];
    //执行取数据函数,
   this.getData(id);
  },
  methods: {
    //根据id匹配相应的数据进行渲染,
    getData(id) {
      //要返回出去的请求回来的对象
      let renderObj = null;
        getCommpany(id)
        .then(res => {
          this.renderArray = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
   
  },
  computed:{
  	  ...mapGetters(['orgIdNum'])
  }
};
</script>

<style lang='less'>
//引入主色调css
@import "../assets/css/mainColor.less";
//上侧移动进来动画
@keyframes topIn {
  0% {
    top: -40vw;
  }
  5% {
    top: -38vw;
  }
  10% {
    top: -36vw;
  }
  15% {
    top: -34vw;
  }
  20% {
    top: -32vw;
  }
  25% {
    top: -30vw;
  }
  30% {
    top: -28vw;
  }
  35% {
    top: -26vw;
  }
  40% {
    top: -24vw;
  }
  45% {
    top: -22vw;
  }
  50% {
    top: -20vw;
  }
  55% {
    top: -18vw;
  }
  60% {
    top: -16vw;
  }
  65% {
    top: -14vw;
  }
  70% {
    top: -12vw;
  }
  75% {
    top: -10vw;
  }
  80% {
    top: -8vw;
  }
  85% {
    top: -4vw;
  }
  90% {
    top: -2vw;
  }
  95% {
    top: 0px;
  }
  100% {
    top: 20px;
  }
}
//下侧移动进来动画
@keyframes rightIn {
  0% {
    right: -40vw;
  }
  5% {
    right: -38vw;
  }
  10% {
    right: -36vw;
  }
  15% {
    right: -34vw;
  }
  20% {
    right: -32vw;
  }
  25% {
    right: -30vw;
  }
  30% {
    right: -28vw;
  }
  35% {
    right: -26vw;
  }
  40% {
    right: -24vw;
  }
  45% {
    right: -22vw;
  }
  50% {
    right: -20vw;
  }
  55% {
    right: -18vw;
  }
  60% {
    right: -16vw;
  }
  65% {
    right: -14vw;
  }
  70% {
    right: -12vw;
  }
  75% {
    right: -10vw;
  }
  80% {
    right: -8vw;
  }
  85% {
    right: -4vw;
  }
  90% {
    right: -2vw;
  }
  95% {
    right: 0px;
  }
  100% {
    right: 20px;
  }
}
.home {
  color: @mainColor;
  .back-button {
    pointer-events: all;
  }
  //左侧公司资料样式,
  .company-introduce-area {
    animation: topIn 0.6s linear;
    height: 83%;
    max-width: 550px;
    min-height: 500px;
    box-sizing: border-box;
    padding: 20px 20px 20px 30px;
    background-image: url(../assets/images/left-down-div.png);
    h1 {
      font-size: 28px;
    }
    video {
      margin-top: 10px;
      width: 100%;
    }
    p {
      height: 40px;
      line-height: 40px;
    }
    p:last-of-type {
      line-height: 20px;
    }
  }
  //右侧样式
  .pd-area {
    animation: rightIn 0.6s linear;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .weather-area {
      width: 50%;
      height: 30%;
      margin-right: 4%;
      max-width: 540px;
      margin-bottom: 20px;
    }
    .scan-area {
      max-width: 540px;
      width: 50%;
      height: 30%;
      margin-right: 4%;
    }
    .main-products-area {
      margin-top: 20px;
      width: 100%;
      height: 35%;
      margin-right: 4%;
      max-width: 880px;
    }
  }
}
</style>